export default function PHP_xml_get_error_code() {
  return (
    <div>
      <h1>PHP_xml_get_error_code</h1>
    </div>
  );
}
